<template>
  <div class="add-additional-field">
    <sTooltip
      v-if="small"
      content="Створити додаткове поле"
      placement="top"
      trigger="hover"
      width="200">
      <sButton
        data-qa="btn-additional-fields-create"
        icon="plus"
        icon-size="12px"
        small
        tabindex="-1"
        type="text"
        @click="open"/>
    </sTooltip>
    <sButton
      v-else
      data-qa="btn-additional-fields-create"
      small
      tabindex="-1"
      type="text"
      @click="open">
      <sIcon
        class="my-auto mr-2"
        size="8"
        type="plus"/>
      {{ $t('AdditionalFields.CreateNew') }}
    </sButton>
    <component
      :is="step.name"
      v-bind="step.options"
      :back_step="steps.length > 1"
      :data-qa="`additional-fields-${step.name}`"
      :item="item"
      :opened="opened"
      @back="back"
      @changeOrder="changeOrder"
      @close="close"
      @createField="createField"
      @deleteField="deleteField"
      @editField="editField"
      @openCreatingField="openCreatingField"
      @openDeletingAllFields="openDeletingAllFields"
      @openDeletingField="openDeletingField"
      @openEditingField="openEditingField"
      @openExistingField="openExistingField"
      @selectExistingFields="selectExistingFields"
      @selectType="selectType"/>
  </div>
</template>
<script>
import SelectExistingField from 'components/additional fields/SelectExistingField.vue'
import CheckAdditionalFields from 'components/additional fields/CheckAdditionalFields.vue'
import CreateAdditionalField from 'components/additional fields/CreateAdditionalField.vue'
import DeleteAdditionalField from 'components/additional fields/DeleteAdditionalField.vue'
import SelectAdditionalFieldType from 'components/additional fields/SelectAdditionalFieldType.vue'

/**
 * файл який створює кроки для доп полів
 * вик-ся на 1 кроці і 3му створення тендера
 * контролює порядок діалогів в залежності від існуючих полів і кліків
 * всі дії з доп полями знаходяться тут
 */
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()
import { additionalFieldsMixin } from 'mixins'
import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const api = new AdditionalFieldsApi()

export default {
  name: 'additionalFields',
  mixins: [additionalFieldsMixin],
  data() {
    return {
      opened: false,
      back_step: false,
      steps: [], // для зберігання куди повертатись
      create_type: {},
      item: null,
      loading: false,
      classifications: [],
      all_existing_fields: []
    }
  },
  methods: {
    selectType(type) {
      this.steps.push('create')
      this.create_type = type
    },
    /**
     * відкриття першого кроку, перший крок в залежності від того чи є уже поля
     */
    async open() {
      this.steps = [this.all_fields?.length ? 'check' : 'select']
      this.loading = true
      await this.$store.dispatch('setAdditionalFieldsTypes')
      this.$nextTick(() => {
        this.opened = true
        this.loading = false
      })

    },
    /**
     * створення поля
     */
    async createField( item ) {
      this.loading = true
      const model = {
        bindingLevel: this.bindingLevel,
        active: true,
        caption: item.name,
        showForBidders: item.show_to_perticipant,
        showAsSpecialField: item.showAsSpecialField,
        id: '00000000-0000-0000-0000-000000000000',
        typeId: item?.typeId || item.type?.typeId,
        settingValues: item.options.map(opt => ({
          id: opt.id,
          value: opt.value,
          settingType: 'SELECT_OPTION'
        }))
      }
      if (item.decimals) {
        model.settingValues.push(
          {
            value: item.decimals + '',
            settingType: 'DECIMALS'
          })
      }

      await api.createAdditionalField(model).then(res => {
        if ( res) {
          let field = {
            fieldValues: [],
            ...item,
            ...res,
            value: '',
            order: this.maxOrder + 1
          }
          this.fields = this.fields.concat([field ])

          this.$emit('addField', field)
          this.close()
        } else {

          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            // message: error?.message || error?.lotMessages.map(er => er.message).join(', '),
            duration: 10,
          })
        }
      })
      this.loading = false
    },
    openCreatingField(  ) {
      this.steps.push('select')
    },
    /**
     * видалення поля - не запросом бо видаляється просто з привязки до тендера
     * Andrii Simachenko - Якщо потрібно його відв'язати від тендера то для цього просто відправляєш bindAdditionaFiledToEntity без цього поля.
     *
     * на цьому рівні в нас є ід після запиту створення поля
     */
    deleteField() {
      this.loading = true
      if (!this.item) {
        this.fields = []
      } else {
        this.fields = this.$_.cloneDeep(this.fields)
          .filter(field => field.id != this.item.id)
          .map((i, index) => ({...i, order: index + 1 }))
      }
      this.close()
      this.loading = false
    },
    openDeletingField(item) {
      this.steps.push('delete')
      this.item = item
    },
    openDeletingAllFields() {
      this.steps.push('delete')
      this.item = null
    },
    async changeOrder(value) {
      const result = this.$_.cloneDeep(this.fields)
      const currentItem = result.find((i) => i.id === value.item.id)
      const oldOrder = currentItem.order
      const newOrder = oldOrder + value.delta

      if (result.find((i) => i.order === newOrder)) {
        result.find((i) => i.order === newOrder).order = oldOrder
      }

      currentItem.order = newOrder
      this.fields = result
      this.$emit('changeOrder')

      /*const oldItem = result.find((i) => i.order === oldOrder)

      await api.updateAdditionalField(oldItem)
      await api.updateAdditionalField(currentItem) */
    },
    async editField(item) {
      this.loading = true
      let options = item.formData.options?.map(opt => ({
          id: opt.id,
          value: opt.value,
          settingType: 'SELECT_OPTION'
        })),
        settingValues = item.settingValues?.filter(opt => opt.settingType != 'SELECT_OPTION').concat(options)

      if (item.typeId === 'DECIMAL') {
        item.decimals = item.formData.decimals
        const index = settingValues?.findIndex(opt => opt.settingType === 'DECIMALS')
        if (index !== -1) {
          settingValues[index].value = item.formData.decimals
        } else {
          settingValues.push(
            {
              value: item.formData.decimals,
              settingType: 'DECIMALS'
            })
        }
      }

      let model = {
        ...item,
        caption: item.formData?.name,
        showForBidders: item.formData?.show_to_perticipant,
        showAsSpecialField: item.formData?.showAsSpecialField,
        settingValues
      }

      await api.updateAdditionalField(model).then(() => {
        const result = this.$_.cloneDeep(this.additional_fields)
        const index = result.findIndex(i => i.id === model.id)
        result[index].caption = model.caption
        result[index].showForBidders = model.showForBidders
        result[index].showAsSpecialField = model.showAsSpecialField
        result[index].settingValues = model.settingValues
        this.fields = result
        this.item = model
        this.close()
      })
      this.loading = false
    },
    async openExistingField() {
      this.steps.push('selectExisting')
      this.loading = true
      await api.getAdditionalFieldsByBindingConditions({
        bindingLevel: ['TENDER', 'LOT']
      }).then(res => {
        const bindings = res ? res.filter(field => field.bindingLevel == this.bindingLevel) : []
        this.all_existing_fields = bindings
        const classificationCodes = []
        bindings.map(
          i => i.bindingCondition.classificationCodes.map(
            ii => classificationCodes.push(ii)
          )
        )
        tender_api.subcategories(classificationCodes)
          .then(classifications => {
            this.classifications = classifications
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    selectExistingFields(items) {
      items.forEach(item => {
        this.$emit('addField', item)
      })
      this.fields = this.fields.concat(items.map((f, index) => ({...f, value: null, order: this.maxOrder + index + 1})))
      this.$nextTick(() => {
        this.close()
      })
    },
    openEditingField( item ) {
      this.steps.push('create')
      this.item = item
    },
    back() {
      this.steps.pop()
    },
    close() {
      this.opened = false
      this.item = null
      setTimeout(() => {
        this.steps = []
      }, 500)
    }
  },
  computed: {
    fields: {
      get() {
        return this.additional_fields
          .filter(field => field.bindingLevel == this.bindingLevel)
          .map(field => ({...field, type: field.type || this.additional_types?.find(type => type.id == field.typeId)}))
          .sort((a, b) => a.order - b.order)
      },
      set(value) {
        this.$emit('update:additional_fields', value)
      }
    },
    all_fields() {
      return this.fields.concat(this.existing_fields?.filter(field => field.bindingLevel == this.bindingLevel))
    },
    /**
     * всі кроки які можна додати
     * і пропси для них
     */
    all_steps() {
      return {
        check: {
          name: 'CheckAdditionalFields',
          options: {
            additional_fields: this.all_fields,
            entity: this.entity,
          }
        },
        create: {
          name: 'CreateAdditionalField',
          options: {
            bindingLevel: this.bindingLevel,
            create_type: !this.item ? this.create_type : {typeId: this.item.typeId},
            loading: this.loading
          }
        },
        select: {
          name: 'SelectAdditionalFieldType',
          options: {
            loading: this.loading
          }
        },
        selectExisting: {
          name: 'SelectExistingField',
          options: {
            loading: this.loading,
            treeItems: this.all_existing_fields,
            existItems: this.all_fields,
            classifications: this.classifications
          }
        },
        delete: {
          name: 'DeleteAdditionalField',
          loading: this.loading
        },
      }
    },
    /**
     * в this.steps записуються ключі з all_steps
     * актуалльний крок завжди буде останній в this.steps так як вони динамічно дадаються - для зберігання куди повертатись
     */
    step() {
      return this.all_steps[ this.steps[this.steps.length - 1] ] || {}
    },
    maxOrder() {
      return Math.max(...(this.additional_fields ?? []).map(i => i.order).concat([0]))
    }
  },
  components: {
    SelectExistingField,
    DeleteAdditionalField,
    CheckAdditionalFields,
    CreateAdditionalField,
    SelectAdditionalFieldType,
  },
  props: {
    /**
     * доп поля
     */
    additional_fields: {
      type: Array,
      required: true
    },
    /**
     * рівень привязки доп полів
     */
    bindingLevel: {
      type: String,
      required: true,
      validator: function (value) {
        const correct = ['TENDER', 'LOT', 'BID', 'TITLE', 'ROW'].indexOf(value) !== -1
        return correct
      },
    },
    /**
     *привязані поля до типу тендера або категорії
     */
    existing_fields: {
      type: Array,
      default: () => ([])
    },
    /**
     * Сущность для привязки
     */
    entity: {
      type: Object
    },
    small: Boolean
  },
}
</script>
